import React from 'react';
import { DownloadIcon, FileTextIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { trustBadges } from '../data/content';
const icons = {
  download: DownloadIcon,
  lock: LockIcon,
  file: FileTextIcon,
  shield: ShieldCheckIcon
};
export function Hero() {
  return <header id="top" className="w-full bg-ink px-5 pb-20 pt-14 text-white sm:px-8" data-id="element-130" data-mp="4jvup7vn12uo">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center text-center" data-id="element-131" data-mp="128pg780q2n1x">
        <Reveal data-id="element-132" data-mp="xaxj7zl80aqv">
          <h1 className="font-display text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl md:text-6xl" data-id="element-133" data-mp="x8bc2128rx96">
            Plan Your Entire Cheer Season{' '}
            <span className="text-cheer" data-id="element-134" data-mp="nbeyvi1eemya">In Under 5 Minutes</span>.
          </h1>
        </Reveal>

        <Reveal delay={0.06} data-id="element-135" data-mp="3d2bhzk51cpsw">
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-136" data-mp="3czfm01cr0b73">
            360+ pages of ready-to-use sessions, drills, stunt progressions and safety
            systems for coaches at every USASF level. Everything done for you.
          </p>
        </Reveal>

        <Reveal delay={0.12} className="w-full" data-id="element-137" data-mp="3o5j39ad4ljlt">
          <div className="mt-10 w-full overflow-hidden rounded-card border border-white/10 bg-[#121218]" data-id="element-138" data-mp="39b4fyxmj3o1c">
            <div className="flex aspect-video w-full items-center justify-center" data-id="element-139" data-mp="3e8egb8bghk3y">
              <img src="https://cdn.magicpatterns.com/uploads/2PXjDTUwtyYueAneqMM1aQ/ChatGPT_Image_15_sept_2026,_18_38_54-Photoroom.png" alt="Cheerleading Ready 360 complete toolkit: six volumes, tablet, desktop and phone mockups with coaching gear" className="h-full w-full object-contain" data-id="element-140" data-mp="30hhsdush5r38" />
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.16} className="w-full" data-id="element-141" data-mp="2hix03zeukfo0">
          <div className="mx-auto mt-10 w-full max-w-md" data-id="element-142" data-mp="2hl9rf36hw2dq">
            <CtaButton data-id="element-143" data-mp="2ljpcv2mxh2p1" />
          </div>

          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-white/70 sm:text-sm" data-id="element-144" data-mp="2lmuyu909fogj">
            {trustBadges.map(badge => {
            const Icon = icons[badge.icon as keyof typeof icons];
            return <li key={badge.label} className="flex items-center gap-2" data-id="element-145" data-mp="icromrj9an9r">
                  <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-146" data-mp="ddwz76qsa0go" />
                  {badge.label}
                </li>;
          })}
          </ul>
        </Reveal>
      </div>
    </header>;
}